import { ButtonType, ButtonWidget, CheckBoxWithLabelWidget, Tooltip } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../codegen/Localize';
import { imgPath } from '../commonInfra/utils/ImgUrl';
import { sanitize } from '../commonInfra/utils/Sanitize';
import { NotificationContainer } from './NotificationContainer';
import {
        tabcldNotificationContainerCheckboxStyle,
        tabcldNotificationContainerCloseButtonStyle,
        tabcldNotificationContainerContentStyle,
        tabcldNotificationContainerControlStyle,
        tabcldNotificationContainerCountStyle,
        tabcldNotificationContainerNextButtonStyle,
        tabcldNotificationContainerPreButtonStyle,
        tabcldNotificationContainerStyle,
        tabcldNotificationContainerTitleStyle,
        tabcldNotificationInfoStyle } from './styles/TabcldNotificationStyles';

export interface NotificationDialogProps {
  readonly index: number;
  readonly notificationContainer: any;
  readonly closeModal: () => void;
}

export interface NotificationCache {
  readonly startingDate: string;
  readonly endingDate: string;
}

export interface NotificationDialogState {
  readonly index: number;
  readonly checked: boolean;
}

export class NotificationDialog extends React.Component<NotificationDialogProps, NotificationDialogState> {
  private index: number;
  private notificationContainer: NotificationContainer;
  private closeModal: () => void;

  constructor(props: NotificationDialogProps) {
    super(props);
    this.index = props.index;
    this.notificationContainer = props.notificationContainer;
    this.closeModal = props.closeModal;
    this.state = {
      index: 0,
      checked: false
    };
  }

  public render() {
    let title = this.getTitle();
    return(
    <div>
        <div id="tabcld_notification_container" style={tabcldNotificationContainerStyle} >
          <div id="tabcld_notification_container_content" style={tabcldNotificationContainerContentStyle}>
            <div style={tabcldNotificationContainerCountStyle}>
              ({this.index+1}/{this.notificationContainer.getSize()})
            </div>
            { (title !== undefined) &&
              <div dangerouslySetInnerHTML={{ __html: sanitize(title) }} style={tabcldNotificationContainerTitleStyle}/>
            }
            <div dangerouslySetInnerHTML={{ __html: sanitize(this.getContent()) }} />
          </div>
          <div id="tabcld_notification_container_checkbox" style={tabcldNotificationContainerCheckboxStyle}>
            <CheckBoxWithLabelWidget
              label={Messages.doNotShowMessageAgain()}
              onChange={this.onChange}
              checked={this.state.checked}
              testId="tabcld-notification-dismiss"
            />
            <Tooltip tooltipContent={Messages.tabCldNotificationDismissInfo()}>
              <span>
                {<img alt={'Dismiss Message'} src={imgPath('info_14px_small.svg')} style={tabcldNotificationInfoStyle}/>}
              </span>
            </Tooltip>
          </div>
          <div id="tabcld_notification_container_control" style={tabcldNotificationContainerControlStyle} >
            {(this.displayPreButton()) && <ButtonWidget buttonType={ButtonType.LowEmphasis} onClick={this.onPreClick} style={tabcldNotificationContainerPreButtonStyle}>
                                              {Messages.tabCldNotificationPreviousMessage()}
                                            </ButtonWidget>}
            {(this.displayNextButton()) && <ButtonWidget buttonType={ButtonType.LowEmphasis} onClick={this.onNextClick} style={tabcldNotificationContainerNextButtonStyle}>
                                              {Messages.tabCldNotificationNextMessage()}
                                            </ButtonWidget>}
            {(this.displayCloseModalButton()) && <ButtonWidget buttonType={ButtonType.LowEmphasis} onClick={this.closeNotificationModal} style={tabcldNotificationContainerCloseButtonStyle}>
                                              {Messages.close()}
                                            </ButtonWidget>}
          </div>
        </div>
    </div>
    );
  }

  public onChange = () => {
    var notification = this.notificationContainer.getNotification(this.index);
    var key = notification.messageKey;

    if (this.state.checked) {
      let value = localStorage.getItem(key);
      if (value != null) {
        localStorage.removeItem(key);
      }
    } else {
      var item = JSON.stringify({'startDate': notification.startDate, 'endDate': notification.endDate});
      localStorage.setItem(key, item);
    }
    this.setState({ index: this.index, checked:!(this.state.checked) });
  };

  public getContent() {
    const htmlString = this.notificationContainer.getNotification(this.index).content;
    return htmlString;
  }

  public getTitle() {
    const title = this.notificationContainer.getNotification(this.index).title;
    return title;
  }

  public getMessageKey() {
    var notification = this.notificationContainer.getNotification(this.index);
    return notification.messageKey;
  }

  public displayNextButton(): boolean {
    var size = this.notificationContainer.getSize();
    if (size > 0 && this.index < (size - 1)) {
      return true;
    } else {
      return false;
    }
  }

  public onNextClick = () => {
    this.index = this.index + 1;
    let value = localStorage.getItem(this.getMessageKey());
    this.setState({ index: this.index, checked: value != null });
  };

  public displayPreButton(): boolean {
    var size = this.notificationContainer.getSize();
    if (size > 0 && this.index > 0) {
      return true;
    } else {
      return false;
    }
  }

  public onPreClick = () => {
    this.index = this.index - 1;
    let value = localStorage.getItem(this.getMessageKey());
    this.setState({ index: this.index, checked: value != null });
  };

  public displayCloseModalButton(): boolean {
    var size = this.notificationContainer.getSize();
    if (size >= 0 && this.index === (size - 1)) {
      return true;
    } else {
      return false;
    }
  }

  public closeNotificationModal = () => {
    this.closeModal();
  };
}